module.exports = __webpack_public_path__ + "static/media/YM72_1.43a6f3e3.jpg";